var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtLock04Filled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8V9.70835C4.75527 11.1186 4 12.9711 4 15C4 19.4183 7.58172 23 12 23C16.4183 23 20 19.4183 20 15C20 12.9711 19.2447 11.1186 18 9.70835V8C18 4.68629 15.3137 2 12 2C8.68629 2 6 4.68629 6 8ZM12 4C9.79086 4 8 5.79086 8 8V8.07026C9.17669 7.38958 10.5429 7 12 7C13.4571 7 14.8233 7.38958 16 8.07026V8C16 5.79086 14.2091 4 12 4ZM13 14C13 13.4477 12.5523 13 12 13C11.4477 13 11 13.4477 11 14L11 16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V14Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtLock04Filled);
export default __webpack_public_path__ + "static/media/at_lock-04-filled.6618137a94111586c85231a4842be682.svg";
export { ForwardRef as ReactComponent };